import { render, staticRenderFns } from "./AdditionalServicesInternationalCiel.vue?vue&type=template&id=ec2b9a1c&"
import script from "./AdditionalServicesInternationalCiel.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicesInternationalCiel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports